



















































































import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import {LocaleMessage} from 'vue-i18n';

import ErrorAnimation from '@/mixins/ErrorAnimation';

import {ImageFile} from '@/components/form/FormTypes';

@Component({})
export default class Input extends Mixins(ErrorAnimation) {
	@Prop({default: null}) readonly variant?: string | null;
	@Prop({default: 'text'}) readonly type?: string;
	@Prop({default: null}) readonly accept?: string | null;
	@Prop({default: false}) readonly disabled?: boolean;
	@Prop({default: () => ([])}) readonly validation?: Array<string>;
	@Prop({default: () => ({})}) readonly onEnter?: Function;
	@Prop({default: () => ({})}) readonly labelCallback?: Function;
	@Prop({default: null}) readonly suffix?: string | null;
	@Prop({default: null}) readonly iconName?: string | null;
	@Prop({default: null}) readonly placeholder?: string | null;
	@Prop({default: null}) readonly tabIndex?: number;
	@Prop({default: ''}) readonly autocomplete?: string;

	@Prop() readonly styles?: CSSStyleDeclaration;
	@Prop() readonly classes?: Array<string>;
	@Prop() readonly label?: string;

	@Prop({default: false}) readonly requiredEmailChange?: boolean;
	@Prop({default: null}) readonly requiredEmailValue?: string | null;
	@Prop({default: null}) readonly originalValue?: string | null;

	fieldName: string = `input@${Math.random()}`;

	$refs: {
		errorMessage: HTMLElement,
		errorPerex: HTMLElement,
		inputField: HTMLInputElement
	};

	isRequired: boolean = false;
	isValid: boolean | null = null;
	isDirty: boolean = false;
	isFocus: boolean = false;
	validateOnChange: boolean = false;
	value: string = '';
	errorMessage: Array<string | null> = [];

	forcedType: string | null = null;

	fileInfo: { name: string, size: string, raw: File } | null = null;

	validationRules: { [key: string]: RegExp } = {
		required: /([^\s])/g,
		email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))|^$/g,
		phone: /^\+?[0-9\s]{7,15}$|^$/g,
		number: /^[0-9]*$/g,
		password: /(((?=.*[0-9])(?=.*[A-Z])(?=.*[\W_]))|((?=.*[0-9])(?=.*[A-Z])(?=.*[a-z]))|((?=.*[0-9])(?=.*[\W_])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[\W_])(?=.*[a-z])))/g,
		zip: /^\d{3}[ ]?\d{2}$/g,
		date: /^\d{2}[./-]\d{2}[./-]\d{4}$/g
	};

	validationValueRules: { [key: string]: Function } = {
		maxLength: (value: number) => `^(.{${value + 1}})`,
		minLength: (value: number) => `^(?!.{${value},}).*$`
	};

	get errorMessages(): { [key: string]: Function } {
		return {
			required: (): LocaleMessage => this.$t('error.form.required'),
			email: (): LocaleMessage => this.$t('error.form.email'),
			phone: (): LocaleMessage => this.$t('error.form.phone'),
			number: (): LocaleMessage => this.$t('error.form.number'),
			password: (): LocaleMessage => this.$t('error.form.password'),
			zip: (): LocaleMessage => this.$t('error.form.zip'),
			date: (): LocaleMessage => this.$t('error.form.date'),
			maxLength: (value: number, fieldValue: string): LocaleMessage => this.$t('error.form.maxLength', {
				current: fieldValue.length,
				limit: value
			}),
			minLength: (value: number): LocaleMessage => this.$t('error.form.minLength', {value}),
		};
	};

	get classList(): Array<string | null> {
		return [
			'input',
			`input--${this.type}`,
			this.requiredEmailChange || (this.isValid !== null && !this.isValid) ? 'input--error' : null,
			this.isFocus ? 'input--focus' : null,
			this.isDirty ? 'input--dirty' : null,
			this.isRequired ? 'input--required' : null,
			this.fileInfo && this.fileInfo.name ? 'input--file-active' : null,
			this.disabled ? 'input--disabled' : null,
			...(this.classes || [])
		];
	}

	@Watch('value')
	onValueChanged(newValue: string | number): void {
		this.$emit('input', newValue);

		this.handleChange(null);
	}

	created(): void {
		this.$nextTick(() => {
			this.isDirty = this.value.length !== 0;

			this.isRequired = this.validation!.map((rule: string): boolean => {
				return rule === 'required';
			})[0];

		});
	}

	getFileInfo(file: File): void {
		this.fileInfo = {
			name: file.name,
			size: this.formatBytes(file.size),
			raw: file
		};
	}

	formatBytes(bytes: number, decimals = 2) {
		if (bytes === 0) return '0 Bytes';

		const k = 1024;
		const dm = decimals < 0 ? 0 : decimals;
		const sizes = ['Bytes', 'KB', 'MB'];

		const i = Math.floor(Math.log(bytes) / Math.log(k));

		return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
	}

	clearFileInput(): void {
		this.fileInfo = null;
		this.value = '';
		this.errorMessage = []
	}

	validate() {
		this.isValid = this.validateConditions().every((condition: boolean) => condition);
		return this.isValid;
	}

	showPassword() {
		this.forcedType = 'text';

	}

	hidePassword() {
		this.forcedType = 'password';
	}

	validateConditions(): Array<boolean> {
		const value = this.type === 'file' ? this.fileInfo ? this.fileInfo.name : '' : this.value;

		const validations = this.validation!.map((rule: string): boolean => {
			const [ruleName, ruleValue] = rule.split('|');

			let matched = value.match(this.validationRules[ruleName]);

			if (ruleValue) {
				let matched = new RegExp(this.validationValueRules[ruleName](parseInt(ruleValue)), 'g');
				return !value.match(matched);
			}

			return !!(matched !== null && matched.length);
		});

		this.errorMessage = validations!.map((valid, validIndex): string | null => {
			if (valid) return null;
			const [ruleName, ruleValue] = this.validation![validIndex].split('|');
			return this.errorMessages[ruleName](ruleValue, this.value);
		}).filter((item) => item !== null);

		return validations;
	}

	handleFocusIn() {
		this.isFocus = true;
	}

	handleFocusOut() {
		this.validateOnChange = this.isDirty;
		this.isFocus = (!!this.value.length && this.isDirty);
		(this.isDirty && this.validation!.length) ? this.validate() : null;
	}

	async handleChange($event: Event | null): Promise<void> {
		if (this.type === 'file') {
			// @ts-ignore
			this.getFileInfo($event.target.files[0]);

			if (!this.validate()) {
				return;
			}

			const image = await this.readFile();

			await this.$store.dispatch('updateBill', {
				image
			});

			return;
		}

		this.isDirty = this.value.length !== 0;
		this.isFocus = (this.value.length >= 0 && this.isDirty);

		(this.isDirty && this.validateOnChange) ? this.validate() : null;
	}

	async readFile(): Promise<ImageFile> {
		const fileInfo = this.fileInfo!;

		return new Promise((resolve) => {
			const reader = new FileReader();
			reader.readAsDataURL(fileInfo.raw);
			reader.onload = () => resolve({
				...fileInfo,
				base64: reader.result
			} as any);
		});
	}
}
